/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class Device {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		// Check if device supports WebGL.
		// see: https://qiita.com/tonkotsuboy_com/items/cdffcdd7bdccac371292
		public static isWebGlAvailable():boolean {
			try {
				const canvas:HTMLCanvasElement = document.createElement('canvas');
				const webGlContext:WebGLRenderingContext = <WebGLRenderingContext>(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
				return !!(window.WebGLRenderingContext && webGlContext && webGlContext.getShaderPrecisionFormat);
			} catch (e) {
				return false;
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------
	}
}
